import { Component, Input } from '@angular/core';

const LEGEND_SIZE_CLASS = {
  small: 'small',
  medium: 'medium',
  large: 'large'
};

@Component({
  selector: 'trend-chart-legend',
  templateUrl: './trend-chart-legend.component.html',
  styleUrls: ['./trend-chart-legend.component.scss']
})
export class TrendChartLegendComponent {
  @Input() legends: string[] = [];
  @Input() size: 'small' | 'medium' | 'large' = 'small';
  @Input() isCount = false;

  legendSizeClass = LEGEND_SIZE_CLASS;

  adjustText(legendText: string) {
    return legendText.length > 20 && this.size === 'small'
      ? legendText.substring(0, 20) + '...'
      : legendText;
  }

  getIconAndColor(idx: number): { icon: string; color: string } {
    if (idx === 0) return { icon: 'line-through-circle', color: '#005DAA' };

    if (this.isCount) return { icon: 'dash-large', color: '#F35200' };

    return { icon: 'dashed-line', color: '#F35200' };
  }
}
